import {Button, ColourSolid, FlexGap, StackHorizontal} from "@twigsby/frontend-framework";
import Lottie from "lottie-react";
import React, {useEffect, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useLocation} from "react-router-dom";
import stringSimilarity from "string-similarity-js";
import notFound from "../Components/Animations/not-found.json";
import {useSite} from "../Providers/SiteInterfaceProvider";
import {PublicRoutes} from "../Routes/PublicRoutes";
import TopRoutes from "../Routes/TopRoutes";

const AuthorisationErrorPage = () => {
    const { t } = useTranslation();
    const{ currentLocale, updatePageMeta, UpdateSiteContact } = useSite();


    useEffect(() => {
        updatePageMeta({
            title: t('routeErrorPage.title')
        });
    }, [currentLocale]);

    return (
        <div className={'flex-column align-center justify-center p-lg'} style={{minHeight: '100%'}}>
            <div className={'animation-framer'}>
                <Lottie animationData={notFound} loop={true} style={{ width: 'auto', height: '100%' }} />
            </div>
            <h1 className={'text-center mt-md mb-xs'}>{t('routeErrorPage.messages.401')}</h1>

            <StackHorizontal gap={FlexGap.Small}>
                <Button title={t('routeErrorPage.actions.accountOverview')} actionLink={{ title: t('routeErrorPage.actions.accountOverview'), url: '/'}} colour={ColourSolid.Secondary} />
                <Button title={t('routeErrorPage.actions.messageUs')} onClick={() => UpdateSiteContact(true)} colour={ColourSolid.Secondary} />
            </StackHorizontal>

        </div>
   );
};

export default AuthorisationErrorPage;
